import React from "react";

export default function Footer() {
  return (
    <div className="footerSection">
      <h1>
        Made by{" "}
        <a href="https://raviranjan-portfolio.netlify.app">Raviranjan Sharma </a>
        with '🧡'
      </h1>
    </div>
  );
}
